module.exports = __webpack_public_path__ + "media/assets/images/icons/binnacle-icon3-a9102af66cd3eaf90ad469933ac8a28a.svg";